"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/cross/index.ts
var cross_exports = {};
__export(cross_exports, {
  ModelDataVisitor: () => ModelDataVisitor,
  NestedReadVisitor: () => NestedReadVisitor,
  NestedWriteVisitor: () => NestedWriteVisitor,
  PrismaWriteActions: () => PrismaWriteActions,
  applyMutation: () => applyMutation,
  enumerate: () => enumerate,
  getFields: () => getFields,
  getIdFields: () => getIdFields,
  getModelFields: () => getModelFields,
  getModelInfo: () => getModelInfo,
  getMutatedModels: () => getMutatedModels,
  getReadModels: () => getReadModels,
  getUniqueConstraints: () => getUniqueConstraints,
  isDelegateModel: () => isDelegateModel,
  requireField: () => requireField,
  resolveField: () => resolveField,
  zip: () => zip
});
module.exports = __toCommonJS(cross_exports);

// src/cross/model-data-visitor.ts
var ModelDataVisitor = class {
  constructor(modelMeta) {
    this.modelMeta = modelMeta;
  }
  /**
   * Visits the given model data.
   */
  visit(model, data, callback) {
    if (!data || typeof data !== "object") {
      return;
    }
    const scalarData = {};
    const subTasks = [];
    for (const [k, v] of Object.entries(data)) {
      const field = resolveField(this.modelMeta, model, k);
      if (field && field.isDataModel) {
        if (field.isArray && Array.isArray(v)) {
          subTasks.push(...v.map((item) => ({ model: field.type, data: item })));
        } else {
          subTasks.push({ model: field.type, data: v });
        }
      } else {
        scalarData[k] = v;
      }
    }
    callback(model, data, scalarData);
    subTasks.forEach(({ model: model2, data: data2 }) => this.visit(model2, data2, callback));
  }
};

// src/cross/model-meta.ts
var import_lower_case_first = require("lower-case-first");
function resolveField(modelMeta, model, field) {
  var _a, _b;
  return (_b = (_a = modelMeta.models[(0, import_lower_case_first.lowerCaseFirst)(model)]) == null ? void 0 : _a.fields) == null ? void 0 : _b[field];
}
function requireField(modelMeta, model, field) {
  const f = resolveField(modelMeta, model, field);
  if (!f) {
    throw new Error(`Field ${model}.${field} cannot be resolved`);
  }
  return f;
}
function getFields(modelMeta, model) {
  var _a;
  return (_a = modelMeta.models[(0, import_lower_case_first.lowerCaseFirst)(model)]) == null ? void 0 : _a.fields;
}
function getUniqueConstraints(modelMeta, model) {
  var _a;
  return (_a = modelMeta.models[(0, import_lower_case_first.lowerCaseFirst)(model)]) == null ? void 0 : _a.uniqueConstraints;
}

// src/cross/mutator.ts
var import_uuid = require("uuid");
var import_deepcopy = __toESM(require("deepcopy"));
function applyMutation(queryModel, queryOp, queryData, mutationModel, mutationOp, mutationArgs, modelMeta, logging) {
  return __async(this, null, function* () {
    if (["count", "aggregate", "groupBy"].includes(queryOp)) {
      return void 0;
    }
    let resultData = queryData;
    let updated = false;
    const visitor = new NestedWriteVisitor(modelMeta, {
      create: (model, args) => {
        if (model === queryModel) {
          const r = createMutate(queryModel, queryOp, resultData, args, modelMeta, logging);
          if (r) {
            resultData = r;
            updated = true;
          }
        }
      },
      createMany: (model, args) => {
        if (model === queryModel && (args == null ? void 0 : args.data)) {
          for (const oneArg of enumerate(args.data)) {
            const r = createMutate(queryModel, queryOp, resultData, oneArg, modelMeta, logging);
            if (r) {
              resultData = r;
              updated = true;
            }
          }
        }
      },
      update: (model, args) => {
        if (model === queryModel) {
          const r = updateMutate(queryModel, resultData, model, args, modelMeta, logging);
          if (r) {
            resultData = r;
            updated = true;
          }
        }
      },
      delete: (model, args) => {
        if (model === queryModel) {
          const r = deleteMutate(queryModel, resultData, model, args, modelMeta, logging);
          if (r) {
            resultData = r;
            updated = true;
          }
        }
      }
    });
    yield visitor.visit(mutationModel, mutationOp, mutationArgs);
    return updated ? resultData : void 0;
  });
}
function createMutate(queryModel, queryOp, currentData, newData, modelMeta, logging) {
  if (!newData) {
    return void 0;
  }
  if (queryOp !== "findMany") {
    return void 0;
  }
  const modelFields = getFields(modelMeta, queryModel);
  if (!modelFields) {
    return void 0;
  }
  const insert = {};
  const newDataFields = Object.keys(newData);
  Object.entries(modelFields).forEach(([name, field]) => {
    var _a, _b, _c, _d;
    if (field.isDataModel) {
      return;
    }
    if (newDataFields.includes(name)) {
      insert[name] = newData[name];
    } else {
      const defaultAttr = (_a = field.attributes) == null ? void 0 : _a.find((attr) => attr.name === "@default");
      if (field.type === "DateTime") {
        if (defaultAttr || ((_b = field.attributes) == null ? void 0 : _b.some((attr) => attr.name === "@updatedAt"))) {
          insert[name] = /* @__PURE__ */ new Date();
        }
      } else if (((_d = (_c = defaultAttr == null ? void 0 : defaultAttr.args) == null ? void 0 : _c[0]) == null ? void 0 : _d.value) !== void 0) {
        insert[name] = defaultAttr.args[0].value;
      }
    }
  });
  const idFields = getIdFields(modelMeta, queryModel, false);
  idFields.forEach((f) => {
    if (insert[f.name] === void 0) {
      if (f.type === "Int" || f.type === "BigInt") {
        const currMax = Array.isArray(currentData) ? Math.max(
          ...[...currentData].map((item) => {
            const idv = parseInt(item[f.name]);
            return isNaN(idv) ? 0 : idv;
          })
        ) : 0;
        insert[f.name] = currMax + 1;
      } else {
        insert[f.name] = (0, import_uuid.v4)();
      }
    }
  });
  insert.$optimistic = true;
  if (logging) {
    console.log(`Optimistic create for ${queryModel}:`, insert);
  }
  return [insert, ...Array.isArray(currentData) ? currentData : []];
}
function updateMutate(queryModel, currentData, mutateModel, mutateArgs, modelMeta, logging) {
  if (!currentData) {
    return void 0;
  }
  if (!(mutateArgs == null ? void 0 : mutateArgs.where) || !(mutateArgs == null ? void 0 : mutateArgs.data)) {
    return void 0;
  }
  let updated = false;
  for (const item of enumerate(currentData)) {
    const visitor = new ModelDataVisitor(modelMeta);
    visitor.visit(queryModel, item, (model, _data, scalarData) => {
      if (model === mutateModel && idFieldsMatch(model, scalarData, mutateArgs.where, modelMeta)) {
        Object.keys(item).forEach((k) => {
          if (mutateArgs.data[k] !== void 0) {
            item[k] = mutateArgs.data[k];
          }
        });
        item.$optimistic = true;
        updated = true;
        if (logging) {
          console.log(`Optimistic update for ${queryModel}:`, item);
        }
      }
    });
  }
  return updated ? (0, import_deepcopy.default)(currentData) : void 0;
}
function deleteMutate(queryModel, currentData, mutateModel, mutateArgs, modelMeta, logging) {
  if (!currentData || !mutateArgs) {
    return void 0;
  }
  if (queryModel !== mutateModel) {
    return void 0;
  }
  let updated = false;
  let result = currentData;
  if (Array.isArray(currentData)) {
    for (const item of currentData) {
      if (idFieldsMatch(mutateModel, item, mutateArgs, modelMeta)) {
        result = result.filter((x) => x !== item);
        updated = true;
        if (logging) {
          console.log(`Optimistic delete for ${queryModel}:`, item);
        }
      }
    }
  } else {
    if (idFieldsMatch(mutateModel, currentData, mutateArgs, modelMeta)) {
      result = null;
      updated = true;
      if (logging) {
        console.log(`Optimistic delete for ${queryModel}:`, currentData);
      }
    }
  }
  return updated ? result : void 0;
}
function idFieldsMatch(model, x, y, modelMeta) {
  if (!x || !y || typeof x !== "object" || typeof y !== "object") {
    return false;
  }
  const idFields = getIdFields(modelMeta, model, false);
  if (idFields.length === 0) {
    return false;
  }
  return idFields.every((f) => x[f.name] === y[f.name]);
}

// src/cross/nested-read-visitor.ts
var NestedReadVisitor = class {
  constructor(modelMeta, callback) {
    this.modelMeta = modelMeta;
    this.callback = callback;
  }
  doVisit(model, field, kind, args) {
    if (this.callback.field) {
      const r = this.callback.field(model, field, kind, args);
      if (r === false) {
        return;
      }
    }
    if (!args || typeof args !== "object") {
      return;
    }
    let selectInclude;
    let nextKind;
    if (args.select) {
      selectInclude = args.select;
      nextKind = "select";
    } else if (args.include) {
      selectInclude = args.include;
      nextKind = "include";
    }
    if (selectInclude && typeof selectInclude === "object") {
      for (const [k, v] of Object.entries(selectInclude)) {
        if (k === "_count" && typeof v === "object" && v) {
          this.doVisit(model, field, kind, v);
        } else {
          const field2 = resolveField(this.modelMeta, model, k);
          if (field2) {
            this.doVisit(field2.type, field2, nextKind, v);
          }
        }
      }
    }
  }
  visit(model, args) {
    this.doVisit(model, void 0, void 0, args);
  }
};

// src/cross/types.ts
var PrismaWriteActions = [
  "create",
  "createMany",
  "connectOrCreate",
  "update",
  "updateMany",
  "upsert",
  "connect",
  "disconnect",
  "set",
  "delete",
  "deleteMany"
];

// src/cross/utils.ts
var import_lower_case_first2 = require("lower-case-first");
function getModelFields(data) {
  return data ? Object.keys(data) : [];
}
function enumerate(x) {
  if (x === null || x === void 0) {
    return [];
  } else if (Array.isArray(x)) {
    return x;
  } else {
    return [x];
  }
}
function zip(x, y) {
  if (Array.isArray(x)) {
    if (!Array.isArray(y)) {
      throw new Error("x and y should be both array or both scalar");
    }
    if (x.length !== y.length) {
      throw new Error("x and y should have the same length");
    }
    return x.map((_, i) => [x[i], y[i]]);
  } else {
    if (Array.isArray(y)) {
      throw new Error("x and y should be both array or both scalar");
    }
    return [[x, y]];
  }
}
function getIdFields(modelMeta, model, throwIfNotFound = false) {
  var _a, _b;
  const uniqueConstraints = (_b = (_a = modelMeta.models[(0, import_lower_case_first2.lowerCaseFirst)(model)]) == null ? void 0 : _a.uniqueConstraints) != null ? _b : {};
  const entries = Object.values(uniqueConstraints);
  if (entries.length === 0) {
    if (throwIfNotFound) {
      throw new Error(`Model ${model} does not have any id field`);
    }
    return [];
  }
  return entries[0].fields.map((f) => requireField(modelMeta, model, f));
}
function getModelInfo(modelMeta, model, throwIfNotFound = false) {
  const info = modelMeta.models[(0, import_lower_case_first2.lowerCaseFirst)(model)];
  if (!info && throwIfNotFound) {
    throw new Error(`Unable to load info for ${model}`);
  }
  return info;
}
function isDelegateModel(modelMeta, model) {
  var _a, _b;
  return !!((_b = (_a = getModelInfo(modelMeta, model)) == null ? void 0 : _a.attributes) == null ? void 0 : _b.some((attr) => attr.name === "@@delegate"));
}

// src/cross/nested-write-visitor.ts
var NestedWriteVisitor = class {
  constructor(modelMeta, callback) {
    this.modelMeta = modelMeta;
    this.callback = callback;
  }
  isPrismaWriteAction(value) {
    return PrismaWriteActions.includes(value);
  }
  /**
   * Start visiting
   *
   * @see NestedWriterVisitorCallback
   */
  visit(model, action, args) {
    return __async(this, null, function* () {
      if (!args) {
        return;
      }
      let topData = args;
      switch (action) {
        case "create":
          topData = topData.data;
          break;
        case "delete":
        case "deleteMany":
          topData = topData.where;
          break;
      }
      yield this.doVisit(model, action, topData, void 0, void 0, []);
    });
  }
  doVisit(model, action, data, parent, field, nestingPath) {
    return __async(this, null, function* () {
      if (!data) {
        return;
      }
      const toplevel = field == void 0;
      const context = { parent, field, nestingPath: [...nestingPath] };
      const pushNewContext = (field2, model2, where, unique = false) => {
        return __spreadProps(__spreadValues({}, context), { nestingPath: [...context.nestingPath, { field: field2, model: model2, where, unique }] });
      };
      switch (action) {
        case "create":
          for (const item of this.enumerateReverse(data)) {
            const newContext = pushNewContext(field, model, {});
            let callbackResult;
            if (this.callback.create) {
              callbackResult = yield this.callback.create(model, item, newContext);
            }
            if (callbackResult !== false) {
              const subPayload = typeof callbackResult === "object" ? callbackResult : item;
              yield this.visitSubPayload(model, action, subPayload, newContext.nestingPath);
            }
          }
          break;
        case "createMany":
          if (data) {
            const newContext = pushNewContext(field, model, {});
            let callbackResult;
            if (this.callback.createMany) {
              callbackResult = yield this.callback.createMany(model, data, newContext);
            }
            if (callbackResult !== false) {
              const subPayload = typeof callbackResult === "object" ? callbackResult : data.data;
              yield this.visitSubPayload(model, action, subPayload, newContext.nestingPath);
            }
          }
          break;
        case "connectOrCreate":
          for (const item of this.enumerateReverse(data)) {
            const newContext = pushNewContext(field, model, item.where);
            let callbackResult;
            if (this.callback.connectOrCreate) {
              callbackResult = yield this.callback.connectOrCreate(model, item, newContext);
            }
            if (callbackResult !== false) {
              const subPayload = typeof callbackResult === "object" ? callbackResult : item.create;
              yield this.visitSubPayload(model, action, subPayload, newContext.nestingPath);
            }
          }
          break;
        case "connect":
          if (this.callback.connect) {
            for (const item of this.enumerateReverse(data)) {
              const newContext = pushNewContext(field, model, item, true);
              yield this.callback.connect(model, item, newContext);
            }
          }
          break;
        case "disconnect":
          if (this.callback.disconnect) {
            for (const item of this.enumerateReverse(data)) {
              const newContext = pushNewContext(field, model, item, typeof item === "object");
              yield this.callback.disconnect(model, item, newContext);
            }
          }
          break;
        case "set":
          if (this.callback.set) {
            for (const item of this.enumerateReverse(data)) {
              const newContext = pushNewContext(field, model, item, true);
              yield this.callback.set(model, item, newContext);
            }
          }
          break;
        case "update":
          for (const item of this.enumerateReverse(data)) {
            const newContext = pushNewContext(field, model, item.where);
            let callbackResult;
            if (this.callback.update) {
              callbackResult = yield this.callback.update(model, item, newContext);
            }
            if (callbackResult !== false) {
              const subPayload = typeof callbackResult === "object" ? callbackResult : typeof item.data === "object" ? item.data : item;
              yield this.visitSubPayload(model, action, subPayload, newContext.nestingPath);
            }
          }
          break;
        case "updateMany":
          for (const item of this.enumerateReverse(data)) {
            const newContext = pushNewContext(field, model, item.where);
            let callbackResult;
            if (this.callback.updateMany) {
              callbackResult = yield this.callback.updateMany(model, item, newContext);
            }
            if (callbackResult !== false) {
              const subPayload = typeof callbackResult === "object" ? callbackResult : item;
              yield this.visitSubPayload(model, action, subPayload, newContext.nestingPath);
            }
          }
          break;
        case "upsert": {
          for (const item of this.enumerateReverse(data)) {
            const newContext = pushNewContext(field, model, item.where);
            let callbackResult;
            if (this.callback.upsert) {
              callbackResult = yield this.callback.upsert(model, item, newContext);
            }
            if (callbackResult !== false) {
              if (typeof callbackResult === "object") {
                yield this.visitSubPayload(model, action, callbackResult, newContext.nestingPath);
              } else {
                yield this.visitSubPayload(model, action, item.create, newContext.nestingPath);
                yield this.visitSubPayload(model, action, item.update, newContext.nestingPath);
              }
            }
          }
          break;
        }
        case "delete": {
          if (this.callback.delete) {
            for (const item of this.enumerateReverse(data)) {
              const newContext = pushNewContext(field, model, toplevel ? item.where : item);
              yield this.callback.delete(model, item, newContext);
            }
          }
          break;
        }
        case "deleteMany":
          if (this.callback.deleteMany) {
            for (const item of this.enumerateReverse(data)) {
              const newContext = pushNewContext(field, model, toplevel ? item.where : item);
              yield this.callback.deleteMany(model, item, newContext);
            }
          }
          break;
        default: {
          throw new Error(`unhandled action type ${action}`);
        }
      }
    });
  }
  visitSubPayload(model, action, payload, nestingPath) {
    return __async(this, null, function* () {
      for (const field of getModelFields(payload)) {
        const fieldInfo = resolveField(this.modelMeta, model, field);
        if (!fieldInfo) {
          continue;
        }
        if (fieldInfo.isDataModel) {
          if (payload[field]) {
            for (const [subAction, subData] of Object.entries(payload[field])) {
              if (this.isPrismaWriteAction(subAction) && subData) {
                yield this.doVisit(fieldInfo.type, subAction, subData, payload[field], fieldInfo, [
                  ...nestingPath
                ]);
              }
            }
          }
        } else {
          if (this.callback.field) {
            yield this.callback.field(fieldInfo, action, payload[field], {
              parent: payload,
              nestingPath,
              field: fieldInfo
            });
          }
        }
      }
    });
  }
  // enumerate a (possible) array in reverse order, so that the enumeration
  // callback can safely delete the current item
  *enumerateReverse(data) {
    if (Array.isArray(data)) {
      for (let i = data.length - 1; i >= 0; i--) {
        yield data[i];
      }
    } else {
      yield data;
    }
  }
};

// src/cross/query-analyzer.ts
var import_lower_case_first3 = require("lower-case-first");
function getReadModels(model, modelMeta, args) {
  const result = /* @__PURE__ */ new Set();
  result.add(model);
  const visitor = new NestedReadVisitor(modelMeta, {
    field: (model2) => {
      result.add(model2);
      return true;
    }
  });
  visitor.visit(model, args);
  return [...result];
}
function getMutatedModels(model, operation, mutationArgs, modelMeta) {
  return __async(this, null, function* () {
    const result = /* @__PURE__ */ new Set();
    result.add(model);
    if (mutationArgs) {
      const addModel = (model2) => void result.add(model2);
      const addCascades = (model2) => {
        const cascades = /* @__PURE__ */ new Set();
        const visited = /* @__PURE__ */ new Set();
        collectDeleteCascades(model2, modelMeta, cascades, visited);
        cascades.forEach((m) => addModel(m));
      };
      const visitor = new NestedWriteVisitor(modelMeta, {
        create: addModel,
        createMany: addModel,
        connectOrCreate: addModel,
        connect: addModel,
        disconnect: addModel,
        set: addModel,
        update: addModel,
        updateMany: addModel,
        upsert: addModel,
        delete: (model2) => {
          addModel(model2);
          addCascades(model2);
        },
        deleteMany: (model2) => {
          addModel(model2);
          addCascades(model2);
        }
      });
      yield visitor.visit(model, operation, mutationArgs);
    }
    result.forEach((m) => {
      getBaseRecursively(m, modelMeta, result);
    });
    return [...result];
  });
}
function collectDeleteCascades(model, modelMeta, result, visited) {
  var _a;
  if (visited.has(model)) {
    return;
  }
  visited.add(model);
  const cascades = (_a = modelMeta.deleteCascade) == null ? void 0 : _a[(0, import_lower_case_first3.lowerCaseFirst)(model)];
  if (!cascades) {
    return;
  }
  cascades.forEach((m) => {
    result.add(m);
    collectDeleteCascades(m, modelMeta, result, visited);
  });
}
function getBaseRecursively(model, modelMeta, result) {
  var _a;
  const bases = (_a = getModelInfo(modelMeta, model)) == null ? void 0 : _a.baseTypes;
  if (bases) {
    bases.forEach((base) => {
      result.add(base);
      getBaseRecursively(base, modelMeta, result);
    });
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ModelDataVisitor,
  NestedReadVisitor,
  NestedWriteVisitor,
  PrismaWriteActions,
  applyMutation,
  enumerate,
  getFields,
  getIdFields,
  getModelFields,
  getModelInfo,
  getMutatedModels,
  getReadModels,
  getUniqueConstraints,
  isDelegateModel,
  requireField,
  resolveField,
  zip
});
//# sourceMappingURL=index.js.map